import { OrganizationApplicationParameters } from '@platform/client/schemas';
import { InlineFormInput } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import { OrgWebsiteShowcase } from './OrgWebsiteShowcase';

type FormValues = {
  website: string;
  linkedIn?: string;
};

export const OrgWebsiteSelection = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress, dataKey } = { ...props };

  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<OrganizationApplicationParameters>(dataKey);

  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      website: getApplicationDataByKey('website') || '',
      linkedIn: getApplicationDataByKey('linkedin') || '',
    },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    updateApplicationData({
      website: data.website,
      linkedin: data.linkedIn,
    });
    onContinue();
  };

  const handleBack = () => {
    updateApplicationData({
      website: watch('website'),
      linkedin: watch('linkedIn'),
    });
    onBack();
  };

  return (
    <ApplicationBackground
      progress={progress}
      isOrganization={true}
      onBack={handleBack}
      onSubmit={handleSubmit(submit)}
      customLeftPanelContent={<OrgWebsiteShowcase />}
      isEditProfile={props.isEditProfile}
    >
      <ApplicationPageContent
        title='Where can people learn more about your organization?'
        description={
          'Having an accessible website is required to apply. LinkedIn is optional. These will be visible on your public profile.'
        }
      >
        <InlineFormInput
          label='Organization website'
          placeholder='Enter website URL'
          prefixContent='http://'
          register={() =>
            register('website', {
              required: "Enter your organization's website to continue",
            })
          }
          errors={errors.website}
        />
        <InlineFormInput
          label='Organization LinkedIn (optional)'
          placeholder='Start typing country name'
          prefixContent='http://'
          register={() => register('linkedIn')}
          errors={errors.linkedIn}
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
